import { LoadingComponent } from './../loading/loading.component';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from './../../services/auth.service';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { ExpedientesService } from "./../../services/expedientes.service";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-expendientes',
  templateUrl: './expendientes.component.html',
  styleUrls: ['./expendientes.component.css']
})
export class ExpendientesComponent implements OnInit {
  
  paginaActual:number;
  filtro={};
  paginaSiguiente:number;
  paginaAnterior:number;
  totalPaginas:number;
  expedientes:any[]=[];
  pagado:number=1;
  ordenacion={};


  constructor(private _auth:AuthService, private _expedientesService:ExpedientesService,
    private activatedRoute:ActivatedRoute, private spinnerService: Ng4LoadingSpinnerService,
    private renderer:Renderer2) {
    
    this.paginaActual=1;
    this.filtro={
      ref :"",
      titulo: "",
      cliente:"",
      usuarioacargo:"",
      fapertura:"",
      fcierre:"",
    };
  }

  ngOnInit() {

    this.ordenacion['campo']="EXcodigo";
    this.ordenacion['orden']="DESC";

    /*this.activatedRoute.queryParams.subscribe(params=>{
      if(params.tipo=="nuevos"){
        this._expedientesService.nuevosExpedientes().subscribe(resp=>{
          this.expedientes=resp["expedientes"];
          if(this.expedientes.length==0){
            this.getExpedientesPorFiltro(this.filtro, this.pagado, this.paginaActual);
          }
        });
      }else{
        this.getExpedientesPorFiltro(this.filtro, this.pagado, this.paginaActual);
      }
    });*/
    this.getExpedientesPorFiltro(this.filtro, this.pagado, this.paginaActual);
    
  }

  getExpedientesPorFiltro(filtro, pagado, pagina){
    
    if(!this._auth.esInterviniente()){

      if(this.activatedRoute.snapshot.queryParams["tipo"]=="nuevos" && this._auth.esAdmin()){
        this._expedientesService.getNuevosExpedientes(filtro, pagado, pagina, this.ordenacion)
        .subscribe(resp=>{
          this.expedientes = resp["expedientes"];

          this.paginaActual=parseInt(resp["pagina"]);
          this.paginaAnterior=parseInt(resp["pag_anterior"]);
          this.paginaSiguiente=parseInt(resp["pag_siguiente"]);
          this.totalPaginas=parseInt(resp["total_paginas"]);
        });
      }else{

        this._expedientesService.getExpedientes(filtro, pagado, pagina, this.ordenacion)
          .subscribe( resp =>{
            this.expedientes = resp["expedientes"];
            
            this.paginaActual=parseInt(resp["pagina"]);
            this.paginaAnterior=parseInt(resp["pag_anterior"]);
            this.paginaSiguiente=parseInt(resp["pag_siguiente"]);
            this.totalPaginas=parseInt(resp["total_paginas"]);
        
        });
      }
      
    }else if(this._auth.esInterviniente()){

      this._expedientesService.getExpedientesByInterviniente(filtro, pagina, this.ordenacion)
        .subscribe(resp=>{
          this.expedientes=resp["expedientes"];
          this.paginaActual=parseInt(resp["pagina"]);
          this.paginaAnterior=parseInt(resp["pag_anterior"]);
          this.paginaSiguiente=parseInt(resp["pag_siguiente"]);
          this.totalPaginas=parseInt(resp["total_paginas"]);
          
        });
    }

    
  }

  buscarExpedientes(){
    this.getExpedientesPorFiltro(this.filtro, this.pagado, this.paginaActual);
  }

  nextPage(){
    this.getExpedientesPorFiltro(this.filtro, this.pagado, this.paginaSiguiente);
  }

  previousPage(){
    this.getExpedientesPorFiltro(this.filtro, this.pagado, this.paginaAnterior);
  }

  borrarExpediente(codigo){
    let respuesta=prompt('Si desea borrar este expediente, escriba "borrar" en el campo de texto.');
    if(respuesta==="borrar"){
      this._expedientesService.borrarExpediente(codigo)
      .subscribe(resp=>{
        alert(resp["mensaje"]);
        if(resp["err"]==false){
          this.getExpedientesPorFiltro(this.filtro, this.pagado, this.paginaActual);
        }
      });
    }else{
      alert("Expediente no borrado.");
    }
  }
  
  limpiarFiltro(){
    this.filtro={
        ref :"",
        titulo: "",
        cliente:"",
        usuarioacargo:"",
        fapertura:"",
        fcierre:""
    };
    
  }

  verTodos(){
    this.limpiarFiltro();
    this.getExpedientesPorFiltro(this.filtro, this.pagado, this.paginaActual);
  }

  switchPagado(i:number){
    this.pagado=i;
    this.getExpedientesPorFiltro(this.filtro, this.pagado, this.paginaActual);
  }

  ordenarTabla(campo){
    
    if(this.ordenacion['campo']==campo && this.ordenacion['orden']=='DESC'){
      this.ordenacion['orden']='ASC';
    }else{
      this.ordenacion['campo']=campo;
      this.ordenacion['orden']='DESC';
    }

    this.getExpedientesPorFiltro(this.filtro, this.pagado, this.paginaActual);
    
  }
  
  

}



// WEBPACK FOOTER //
// ./src/app/components/expendientes/expendientes.component.ts